import React from 'react';
import {
  ConfigApparatusIcon as Settings,
  RemoveCuvetteIcon as RemoveCuvette,
} from '../../Icons';
import {
  Info2,
  Info3,
  Info4,
  Info5,
  Info6,
  Info7,
} from './SpectrophotometerImages';

export function useSpectrophotometer() {
  function getButtonList(params) {
    let buttonList = [];

    if (!params.showSettingsModal) {
      buttonList.push({
        image: Settings,
        altText: 'Spectrophotometer settings',
        onClick: params.toggleSettingsModal,
      });
    }

    if (!params.showInfoModal) {
      buttonList.push({
        label: 'Info',
        onClick: params.openInfoModal,
      });
    }

    if (params.lidOpen) {
      buttonList.push({
        label: 'Close',
        onClick: params.toggleLid(false),
      });
    } else {
      buttonList.push({
        label: 'Open',
        onClick: params.toggleLid(true),
      });
    }

    if (hasItem(params.cuvetteId) && params.lidOpen) {
      buttonList.push({
        image: RemoveCuvette,
        altText: 'Remove cuvette',
        onClick: () => params.removeCuvette(params.cuvetteId),
      });
    }

    return buttonList;
  }

  return {getButtonList};
}

export function hasItem(itemId) {
  return typeof itemId === 'number' && itemId >= 0;
}

export const INFO_TABS = [
  {label: 'How it works', current: true},
  {label: 'Parts', current: false},
];

export const INFO_TAB_TYPES = {
  PARTS: INFO_TABS[1].label,
  HOW_IT_WORKS: INFO_TABS[0].label,
};

export const PARTS_ACCORDIAN = [
  {
    id: 0,
    label: 'Power button',
    Image: Info2,
    description:
      'After turning on the spectrophotometer, the lamp inside needs to warm up for 15 minutes.',
    open: false,
  },
  {
    id: 1,
    label: 'Zero button',
    Image: Info3,
    description:
      'Allows for setting the absorbance of a blank control to zero. In our case, the blank is a cuvette containing water that is used as a reference point by the spectrophotometer when measuring other solutions.',
    open: false,
  },
  {
    id: 2,
    label: 'Wavelength dial',
    Image: Info4,
    description:
      'Turning this button adjusts the wavelength of emitted light by the lamp between 350 and 750 nm.',
    open: false,
  },
  {
    id: 3,
    label: 'Absorbance display',
    Image: Info5,
    description:
      'Shows the current absorbance of the sample in the cuvette inside the chamber.',
    open: false,
  },
  {
    id: 4,
    label: 'Chamber lid',
    Image: Info6,
    description:
      'Opening the lid allows access to the chamber where the cuvette is placed.',
    open: false,
  },
  {
    id: 5,
    label: 'Open chamber',
    Image: Info7,
    description: 'With the lid open, the cuvette is placed into a square opening that holds it in place. It is important to orient the cuvette correctly so that the clear sides of the cuvette face the light path in the instrument.',
    open: false,
  },
];

export const ACCORDIAN_SMALL = [
  {
    id: 0,
    label: 'Power button',
    description:
      'After turning on the spectrophotometer, the lamp inside needs to warm up for 15 minutes.',
    open: true,
  },
  {
    id: 1,
    label: 'Zero button',
    description:
      'Allows for setting the absorbance of a blank control to zero. In our case, the blank is a cuvette containing water that is used as a reference point by the spectrophotometer when measuring other solutions.',
    open: false,
  },
  {
    id: 2,
    label: 'Wavelength dial',
    description:
      'Turning this button adjusts the wavelength of emitted light by the lamp between 350 and 750 nm.',
    open: false,
  },
];
